import type { ReactNode } from 'react';
import type { MarketSelectorItem } from '../../MarketSelector/types';
import { MarketDataCardMarketSelectorProvider } from '../MarketDataCardMarketSelectorContext';
import type { PersistMarketDataCardMarketSelection } from '../useMarketDataCardMarketSelector';
import { useMarketDataCardQuickMarketSelectorControls } from './useMarketDataCardQuickMarketSelectorControls';

export function MarketDataCardQuickMarketSelectorProvider({
  isOpen,
  selectedMarkets,
  selectedMarketAccounts,
  selectedAggregation,
  marketSelectorItems,
  onPersistMarketSelection,
  children,
}: {
  isOpen: boolean;
  selectedMarkets: string[];
  selectedMarketAccounts: string[];
  selectedAggregation: string | undefined;
  marketSelectorItems: MarketSelectorItem[];
  onPersistMarketSelection: (update: PersistMarketDataCardMarketSelection) => void;
  children: ReactNode;
}) {
  const marketSelectorControls = useMarketDataCardQuickMarketSelectorControls({
    isOpen,
    selectedMarkets,
    selectedMarketAccounts,
    selectedAggregation,
    marketSelectorItems,
    onPersistMarketSelection,
  });

  return (
    <MarketDataCardMarketSelectorProvider value={marketSelectorControls}>
      {children}
    </MarketDataCardMarketSelectorProvider>
  );
}
